/** Match Angular `workflow_type | replace: '_':' '` in dropdowns and list. */
export function formatWorkflowLabel(workflowType: string | undefined | null): string {
  if (workflowType == null || workflowType === '') return ''
  return workflowType.split('_').join(' ')
}
